import React from 'react';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import {
  AssignmentTaskValueTypeValueRange,
  AssignmentTaskValueTypes
} from 'constants/assignments';
import { isEmpty, isNull, map } from 'lodash';

import { AssignmentStatusHorizontal, Typography } from 'pages/Students/shared';
import { ReactComponent as CheckIcon } from 'pages/Students/shared/TaskInfo/assets/check.svg';
import { ReactComponent as CheckMinusIcon } from 'pages/Students/shared/TaskInfo/assets/check_minus.svg';
import { ReactComponent as CheckPlusIcon } from 'pages/Students/shared/TaskInfo/assets/check_plus.svg';
import { ReactComponent as CorrectIcon } from 'pages/Students/shared/TaskInfo/assets/correct.svg';
import { ReactComponent as IncorrectIcon } from 'pages/Students/shared/TaskInfo/assets/incorrect.svg';
import { ReactComponent as TextIcon } from 'pages/Students/shared/TaskInfo/assets/text.svg';
import { getTaskName } from 'pages/Students/utils';
import { colors } from 'theme/palette';

import styles from './styles.module.scss';

const StyledCheckCircleRoundedIcon = withStyles({
  root: {
    width: 14,
    height: 14,
    color: 'var(--grey-1)',
    '&.green': {
      color: 'var(--green)'
    }
  }
})(CheckCircleRoundedIcon);

export const LightTaskInfo = ({ task, lgScreen }) => {
  const getTaskValueIcon = () => {
    if (task.value_type === AssignmentTaskValueTypes.CHECK_GRADE) {
      return {
        0: (
          <div className={styles.roundIconContainer}>
            <CheckIcon fill={colors.white} />
          </div>
        ),
        '-1': (
          <div className={styles.roundIconContainer}>
            <CheckMinusIcon fill={colors.white} />
          </div>
        ),
        1: (
          <div className={styles.roundIconContainer}>
            <CheckPlusIcon fill={colors.white} />
          </div>
        )
      }[task.value];
    }
    if (task.value_type === AssignmentTaskValueTypes.CHECKBOX) {
      return {
        0: (
          <div className={styles.squareIconContainer}>
            <IncorrectIcon
              fill={colors.grey1}
              style={{ backgroundColor: colors.grey5 }}
            />
          </div>
        ),
        1: (
          <div
            className={styles.squareIconContainer}
            style={{ backgroundColor: colors.green }}
          >
            <CorrectIcon fill={colors.grey1} />
          </div>
        )
      }[task.value];
    }
    if (task.value_type === AssignmentTaskValueTypes.RUBRIC_ZERO_FOUR) {
      return (
        <div
          className={styles.squareIconContainer}
          style={{ backgroundColor: colors.green }}
        >
          <Typography variant="S-TEXT-2" color={colors.blue2}>
            {task.value}
          </Typography>
        </div>
      );
    }
    if (task.value_type === AssignmentTaskValueTypes.RUBRIC_A_TO_F) {
      return (
        <div
          className={styles.squareIconContainer}
          style={{ backgroundColor: colors.green }}
        >
          <Typography variant="S-TEXT-2" color={colors.blue2}>
            {task.raw_value}
          </Typography>
        </div>
      );
    }
    if (task.value_type === AssignmentTaskValueTypes.PERFORMANCE) {
      return (
        <div
          className={styles.performanceObjective}
          style={{ backgroundColor: colors.green }}
        >
          <Typography variant="S-TEXT-1" color={colors.blue1}>
            {
              AssignmentTaskValueTypeValueRange[
                AssignmentTaskValueTypes.PERFORMANCE
              ][task.raw_value]
            }
          </Typography>
        </div>
      );
    }
    if (task.value_type === AssignmentTaskValueTypes.TEXT) {
      return <TextIcon fill={colors.blue5} />;
    }
    return (
      <Typography variant="S-TEXT-1" color={colors.blue2}>
        {task.value}
      </Typography>
    );
  };

  const hasScore = !isNull(task.raw_value);

  return (
    <div className={styles.lightTask}>
      <Grid container alignItems="center" className={styles.taskInfo}>
        <Grid item xs={3}>
          <Typography
            variant={lgScreen ? 'S-TEXT-2' : 'S-TEXT-4'}
            color={colors.grey1}
          >
            STATUS
          </Typography>
        </Grid>
        <Grid item xs={9}>
          <AssignmentStatusHorizontal
            status={task.status}
            light={false}
            lgScreen={lgScreen}
          />
        </Grid>
      </Grid>
      {hasScore && (
        <Grid container alignItems="center" className={styles.taskInfo}>
          <Grid item xs={3}>
            <Typography
              variant={lgScreen ? 'S-TEXT-2' : 'S-TEXT-4'}
              color={colors.grey1}
            >
              SCORE
            </Typography>
          </Grid>
          <Grid item xs={9} container spacing={1} alignItems="center">
            <Grid item>{getTaskValueIcon()}</Grid>
            <Grid item>
              <Typography
                variant={lgScreen ? 'S-TEXT-1' : 'S-TEXT-2'}
                display="inline"
                color={colors.blue2}
              >
                {getTaskName(task.value_type, task.value)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      {!isEmpty(task.criteria) && (
        <Grid container alignItems="flex-start" className={styles.taskInfo}>
          <Grid item xs={3}>
            <Typography
              variant={lgScreen ? 'S-TEXT-2' : 'S-TEXT-4'}
              color={colors.grey1}
            >
              CRITERIA FOR
              <br />
              SUCCESS
            </Typography>
          </Grid>
          <Grid item xs={9}>
            {map(task.criteria, ({ name, value }, index) => (
              <Grid container alignItems="center" spacing={1} key={index}>
                <Grid item style={{ display: 'flex' }}>
                  <StyledCheckCircleRoundedIcon
                    className={value ? 'green' : 'white'}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    variant={lgScreen ? 'B-Text-2' : 'B-Text-3'}
                    color={colors.blue2}
                  >
                    {name}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
    </div>
  );
};
